import { React, Image, View } from '@/lib'
import { Theme } from '@/app'
import { Assets } from '@/assets'

export const Scientists = () => {
  return (
    <View style={styles.wrapper}>
      <Image src={Assets.Misc.rocket_science} style={styles.image}/>
    </View>
  )
}

export default Scientists

const styles = {
  wrapper: {
    marginBottom: Theme.spacing(2),
  },
  image: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    height: '100%',
    maxHeight: 300,
    objectFit: 'cover',
    borderRadius: Theme.values.borderRadius.small,
    [Theme.media.down('mid')]: {
      height: '60vw',
    },
  },
}
